import { render, staticRenderFns } from "./ConsignmentOverview.vue?vue&type=template&id=2a595d88"
import script from "./ConsignmentOverview.vue?vue&type=script&lang=js"
export * from "./ConsignmentOverview.vue?vue&type=script&lang=js"
import style0 from "./ConsignmentOverview.vue?vue&type=style&index=0&id=2a595d88&prod&lang=css"
import style1 from "./ConsignmentOverview.vue?vue&type=style&index=1&id=2a595d88&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports